import React, { FC } from 'react'
import { Button } from 'antd'
import { ButtonProps } from 'antd/lib/button'
import styled from '@emotion/styled'

const DDGhostBtn: FC<ButtonProps> = ({ children, ...props }) => {
  return <StyledDDGhostBtn {...props}>{children}</StyledDDGhostBtn>
}

const StyledDDGhostBtn = styled(Button)`
  background: transparent;
  height: 28px;
  min-width: 78px;
  padding: 0;
  font-size: 14px;
  color: var(--main-button-bg-color);
  border: 1px solid var(--main-button-bg-color);
  border-radius: 4px;
  &:focus {
    color: var(--main-button-bg-color);
    border: 1px solid var(--main-button-bg-color);
    background: transparent;
  }
  &:hover {
    background: var(--main-button-bg-color);
    color: var(--main-button-text-color);
    border-color: var(--main-button-bg-color);
  }
  &.ant-btn:not([disabled]):hover {
    background: var(--main-button-bg-color);
    color: var(--main-button-text-color);
    border-color: var(--main-button-bg-color);
  }
  &.ant-btn-round {
    border-radius: 32px;
  }
  &.disable {
    background: var(--btn-disabled-bg) !important;
    border-color: var(--btn-disabled-border) !important;
    color: var(--btn-disabled-color) !important;
    opacity: 0.5;
  }
`
export default DDGhostBtn
